module.exports = __webpack_public_path__ + "assets/img/page-header-bg@3x.d3dcedd7.png";